module.exports = __webpack_public_path__ + "img/icon-no-pic.ba551dd0.png";